export default {
  everyText: '毎',
  periodLabel: '',
  atEveryText: '',
  minuteLabel: '分',
  atOptionLabel: '当時',
  everyOptionLabel: 'おきに',
  betweenText: '',
  inText: '',
  onText: '',
  andText: '〜',
  monthLabel: '月',
  dayOfWeekLabel: '曜日',
  onEveryText: '',
  multiDayOfMonthLabel: '日',
  dayOfMonthLabel: '日',
  hourLabel: '時',
  weekDaysOptions: [
    '日曜日',
    '月曜日',
    '火曜日',
    '水曜日',
    '木曜日',
    '金曜日',
    '土曜日',
  ],
  periodOptions: ['時', '日', '週', '月', '年'],
  shortMonthOptions: [
    '1月',
    '2月',
    '3月',
    '4月',
    '5月',
    '6月',
    '7月',
    '8月',
    '9月',
    '10月',
    '11月',
    '12月',
  ],
  onOptionLabel: '当日',
  lastDayOfMonthLabel: '月末日',
  cronDescriptionText: 'ja',
}